import React from "react";
import { Box, Button, Typography } from "@mui/material";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";

interface CardTrainingProps {
  title: string;
  text: string;
  icon: React.ReactNode;
  buttonText: string;
  onClick: () => void;
}
const CardTraining = ({
  title,
  text,
  icon,
  buttonText,
  onClick,
}: CardTrainingProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems:"flex-start",
        padding: "30px",
        border: "1px solid #00000021",
        borderRadius: "12px",
        width: "100%",
        height: "266px",
        boxSizing: "border-box",
      }}
    >
      <Box
        sx={{
          width: 76,
          height: 76,
          flexShrink: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#E8F6F6",
          borderRadius: "9px",

          "& img": {
            width: 32,
            height: 32,
            objectFit: "contain",
            display: "block",
          },
        }}
      >
        {icon}
      </Box>
      <Typography variant="h6">{title}</Typography>
      <Typography variant="body2" color="#716E6EDE">
        {text}
      </Typography>
      <Button
        onClick={onClick}
        sx={{
          display: "flex",
          flexDirection: "row",
          cursor: "pointer",
          fontWeight: 600,
          color: "#2CA6A4",
        }}
      >
        {buttonText}
        <ArrowForwardOutlinedIcon />
      </Button>
    </Box>
  );
};
export default CardTraining;
